import { createFileRoute } from '@tanstack/react-router';
import { CasinoLobby } from '@/ui/casino';

export const Route = createFileRoute('/casino/')({
  component: CasinoLobby,
});
